import request from "../request";
import sysrequest from "../sysrequest";
// search condition API

const api = {
  // 標籤查詢br
  query_br_tags(data) {
    const obj = {
      url: "/bid/demo_v1/tags/query_br_tags/",
      method: "post",
      data,
    };
    if (data.isSys) return sysrequest(obj);
    else return request(obj);
  },

  // 新增類別標籤
  add_category_tag(data) {
    const obj = {
      url: "/bid/demo_v1/tags/add_category_tag/",
      method: "post",
      data,
    };
    if (data.isSys) return sysrequest(obj);
    else return request(obj);
  },
  // 刪除類別標籤
  delete_category_tag(data) {
    const obj = {
      url: "/bid/demo_v1/tags/delete_category_tag/",
      method: "post",
      data,
    };
    if (data.isSys) return sysrequest(obj);
    else return request(obj);
  },

  // 更新類別標籤
  update_category_tags(data) {
    const obj = {
      url: "/bid/demo_v1/tags/update_category_tag/",
      method: "post",
      data,
    };
    if (data.isSys) return sysrequest(obj);
    else return request(obj);
  },

  // 總公司標籤查詢
  query_hq_tags(data) {
    const obj = {
      url: "/bid/demo_v1/tags/query_hq_tags/",
      method: "post",
      data,
    };
    if (data.isSys) return sysrequest(obj);
    else return request(obj);
  },

  // 新增總公司標籤
  add_hq_category_tag(data) {
    const obj = {
      url: "/bid/demo_v1/tags/add_hq_category_tag/",
      method: "post",
      data,
    };
    if (data.isSys) return sysrequest(obj);
    else return request(obj);
  },

  // 更新總公司標籤
  update_hq_category_tag(data) {
    const obj = {
      url: "/bid/demo_v1/tags/update_hq_category_tag/",
      method: "post",
      data,
    };
    if (data.isSys) return sysrequest(obj);
    else return request(obj);
  },

  // 刪除總公司標籤
  delete_hq_category_tag(data) {
    const obj = {
      url: "/bid/demo_v1/tags/delete_hq_category_tag/",
      method: "post",
      data,
    };
    if (data.isSys) return sysrequest(obj);
    else return request(obj);
  },

  // 查詢標準標籤
  query_standard_tags(data) {
    const obj = {
      url: "/bid/demo_v1/tags/query_standard_tags/",
      method: "post",
      data,
    };
    if (data.isSys) return sysrequest(obj);
    else return request(obj);
  },

  // 更新標準標籤
  update_standard_tags(data) {
    const obj = {
      url: "/bid/demo_v1/tags/update_standard_tag/",
      method: "post",
      data,
    };
    if (data.isSys) return sysrequest(obj);
    else return request(obj);
  },

  // 刪除標準標籤
  delete_standard_tag(data) {
    const obj = {
      url: "/bid/demo_v1/tags/delete_standard_tag/",
      method: "post",
      data,
    };
    if (data.isSys) return sysrequest(obj);
    else return request(obj);
  },
};

export default api;
